<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Notícias" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
   <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
  <section class="content">
    <div class="card">
      <div class="card-body">
        <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
          <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
          <b-spinner class="ml-2" variant="danger"></b-spinner>
        </div>
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <form class="forms-sample">
                  <div class="form-row">
                    <div class="form-group">
                      <label for="inputDate" class="required">Data</label>
                      <Datefield v-model="formulario.date" :classField="'form-control'" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"/>
                      <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.date}}</div>
                    </div>
                    <div class="form-group col-sm">
                      <label for="inputTitle" class="required">Título</label>
                      <input type="text" v-model="formulario.title" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputTitle">
                      <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.title}}</div>
                    </div>
                    <div class="form-group col-md-12">
                      <label for="textAreaSummary" class="required">Síntese</label>
                      <ckeditor :editor="editorDeTexto.editor" v-model="formulario.summary" :config="editorDeTexto.config" :isReadOnly="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"></ckeditor>
                      <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.summary}}</div>
                    </div>
                    <div class="form-group col-md-12">
                      <label for="inputText" class="required">Texto</label>
                      <ckeditor :editor="editorDeTexto.editor" v-model="formulario.text" :config="editorDeTexto.config" :isReadOnly="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"></ckeditor>
                      <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.text}}</div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="inputAuthor" class="required">Autor</label>
                      <input type="text" v-model="formulario.author" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputAuthor">
                      <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.author}}</div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="inputsource">Fonte</label>
                      <input type="text" v-model="formulario.source" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputSource">
                      <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.source}}</div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="inputSource_link">Link</label>
                      <input type="text" v-model="formulario.source_link" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputSource_link" placeholder="http://www.exemplo.com.br">
                      <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.source_link}}</div>
                    </div>
                    <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                      <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                      <b-spinner class="ml-2" variant="danger"></b-spinner>
                    </div>
                  </div>
                </form>
              </div>
              <div class="card-footer text-right">
                <div class="row btn-group btn-group-justified" role="group">
                  <div class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" @click="salvarRegistro()">Salvar</b-button></div>
                  <router-link class="" to="/administracao-noticias">
                    <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Cancelar</b-button>
                  </router-link>
                </div>
              </div>
            </div><!-- card ends -->
          </div>
        </div><!-- row ends -->
      </div>
    </div>
    <!-- Default box -->

    <!-- /.card -->
  </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</div>
<!-- ./wrapper -->
</template>

<script>
import Cadastro from './js/cadastro-noticias'
export default Cadastro
</script>

<style scoped>
@import "./scss/noticias.scss";
</style>
